export const mobileScreen = 768;
export const tabletScreen = 1024;
//  ----------- colors -------------
export const redColor = "#D40000"; // rouge foncé
export const redOrangeColor = "#F24B35"; // rouge-orange
export const orangeColor = "#FF9430"; // orange
export const yellowColor = "#FFAE00"; // jaune
export const lightYellowColor = "#F2C335"; // jaune clair
export const greyColor = "#d1d5db"; // grey

// --------- current path ------------
export const getCurrentPath = () => {
  if (typeof window !== "undefined") {
    return window.location.pathname + window.location.search + window.location.hash;
  }
  return "";
};

// ---------- Origin -----------
export const getOrigin = () => {
  if (typeof window !== "undefined") {
    return window.location.origin;
  }
  return "";
};

// ----------- h2 font-size ------------
export const h2FontSize = " xs:text-xl md:text-3xl lg:text-4xl";
// ----------- h1 font-size ----------
export const h1FontSize = "xs:text-2xl md:text-3xl lg:text-5xl";
